export default __webpack_public_path__ + "03b10e4ed83cbf1c20f98129b777b603.png";